module.exports = __webpack_public_path__ + "images/fa-file-certificate-light.svg";